import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DropDown } from 'anf-core-react';

const propTypes = {
  countryList: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
  selectedCountry: PropTypes.string,
  onCountryChange: PropTypes.func,
  label: PropTypes.string,
  isInvalid: PropTypes.bool,
  errorMessage: PropTypes.string,
};

const defaultProps = {
  countryList: [],
  selectedCountry: '',
  onCountryChange: () => {},
  label: 'Country',
  isInvalid: false,
  errorMessage: '',
};

export default function CountrySelector({
  countryList,
  selectedCountry,
  onCountryChange,
  label,
  isInvalid,
  errorMessage,
}) {
  const [currentCountry, setCurrentCountry] = useState(selectedCountry);

  // Update local state when selectedCountry prop changes
  useEffect(() => {
    setCurrentCountry(selectedCountry);
  }, [selectedCountry]);

  const handleCountryChange = (event) => {
    const newCountry = event.target.value;
    setCurrentCountry(newCountry);
    onCountryChange(newCountry);
  };

  // Convert countryList to options dropdown
  const options = countryList.map((country) => ({
    label: country.label || country.value,
    value: country.value,
  }));

  return (
    <div className="wss-country-selector">
      <DropDown
        id="wss-billing-country"
        label={label}
        onChange={handleCountryChange}
        options={options}
        value={currentCountry}
        name="billingCountry"
        isInvalid={isInvalid}
      />
      {isInvalid && errorMessage && (
        <div className="error-message" role="alert">
          {errorMessage}
        </div>
      )}
    </div>
  );
}

CountrySelector.propTypes = propTypes;
CountrySelector.defaultProps = defaultProps;
